var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingCareCoordination(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560.82 581.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7404;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.9,296.04c-25.13,10.91-46.65,28.56-62.29,50.68-1.78,.06-3.59,.12-5.42,.2h-101.88c-110.96-4.65-128.57,22.04-124.48,146.85v87.46H0v-150.83c0-81.09,54.29-135.5,135.27-135.5h197.85c6.79,0,13.39,.38,19.78,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    className: "cls-1",
    d: "M235.06,267.92c-74.19-.04-134.29-60.22-134.25-134.4,.03-53.93,32.31-102.61,81.98-123.63,68.74-27.89,147.08,5.23,174.97,73.97,27.34,67.38-3.9,144.27-70.48,173.5-16.52,7-34.28,10.59-52.22,10.56Zm0-208.9c-41.2,0-74.61,33.4-74.61,74.61s33.4,74.61,74.61,74.61,74.61-33.4,74.61-74.61c-.04-41.19-33.42-74.56-74.61-74.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M412.11,283.78c-21.05,0-41.06,4.37-59.2,12.26h-.01c-25.13,10.91-46.65,28.56-62.29,50.68-17.14,24.23-27.22,53.83-27.22,85.78,0,81.31,65.26,147.4,146.28,148.7,.81,.01,1.62,.02,2.44,.02v-58.72c-.82,0-1.63,0-2.44-.03-48.58-1.3-87.56-41.09-87.56-89.97,0-33.15,17.91-62.09,44.58-77.72h.01c13.33-7.81,28.85-12.28,45.41-12.28,11.55,0,22.59,2.17,32.73,6.14,33.52,13.09,57.26,45.7,57.26,83.86h58.72c0-82.14-66.58-148.72-148.71-148.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458.38,
    y: 450.29,
    width: 29.36,
    height: 83.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "426.78 359.06 426.78 441.7 397.42 471.05 378.25 490.22 357.49 469.46 397.42 429.54 397.42 359.06 426.78 359.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458.38,
    y: 551.87,
    width: 29.36,
    height: 29.36
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingCareCoordination);
export default __webpack_public_path__ + "static/media/pendingCareCoordination.723058c18e2419df8a6ffd4890fd7f43.svg";
export { ForwardRef as ReactComponent };